import { httpPut } from '../../../../Util/http';
import { addAlert } from '../../../../MsgNotify/msgNotifyActions';


export const UPDATE_MEASUREMENT = 'UPDATE_MEASUREMENT'
export const updateMeasurement = (typeOf, index, value) => (
  {
    type: UPDATE_MEASUREMENT,
    typeOf,
    index,
    value
  }
)

export const ADD_MEASSUREMENT = 'ADD_MEASSUREMENT'
export const addMeasurement = () => (
  {
    type: ADD_MEASSUREMENT,
    measurement: { type: "", length: 0, depth: 0, area: "", amount: 0 }
  }
)



export function attemptSaveMeasurements(currentDailyReportId, getState, dispatch) {
  var _url = process.env.REACT_APP_webApiEndPoint + 'api/dailyreport/measurements/register'
  let measurements = getState().dailyReportMeasurementsReducer.measurements;
  let measurementsToSave = filterSaveAbleMeasurements(measurements);
  return httpPut(_url, { id: currentDailyReportId, measurements: measurementsToSave })
    .catch(() => {
      dispatch(addAlert("Kunne ikke gemme udførelse"))
      throw new Error("Kunne ikke gemme udførelse")
    })
}


function filterSaveAbleMeasurements(measurements) {
  let result = [];
  measurements.forEach((m) => {
    if (m.type && m.type !== "0") {
      result.push(m);
    }
  })
  return result;
}


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Measurements/actions.js